import React from 'react';
export function PainPoints() {
  return <section className="w-full overflow-hidden" data-id="element-159">
      <img src="https://cdn.magicpatterns.com/uploads/9GnpLd49BMDyvvALWMspPa/463fcac2-f46a-4606-bc65-de136b7dce7d.webp" alt="El amor no es suficiente para sanar un sistema familiar" className="w-full h-auto block" data-id="element-160" />
    </section>;
}